/* eslint-disable import/prefer-default-export */
export const BASE_URL =
  window.location.origin === 'https://cadastrar.bizut.com.br'
    ? 'https://bizut.com.br'
    : 'https://bizut.net';
